module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "uploadImg"
    }
  }, [(_vm.snackbar) ? _c('mu-snackbar', {
    staticStyle: {
      "background-color": "#fff",
      "color": "red"
    },
    attrs: {
      "message": "仅支持JPG、JPEG、PNG图片，且图片大小200KB以内"
    },
    on: {
      "close": _vm.hideSnackbar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-name"
  }, [_c('img', {
    staticClass: "imgStyle",
    attrs: {
      "id": "showImage",
      "src": _vm.imgPath,
      "onerror": "this.src='/public/image/patient.png';this.onerror=null;"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.errorInfo))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hoverFlag),
      expression: "hoverFlag"
    }],
    staticClass: "danger"
  }), _vm._v(" "), _c('a', {
    staticClass: "file pointer",
    on: {
      "click": _vm.showClick
    }
  }, [_vm._v("\n      更换头像\n    ")]), _vm._v(" "), (!_vm.showUp) ? _c('input', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "changeImage"
    },
    on: {
      "change": function($event) {
        _vm.setImagePreview(1)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "width": "80",
      "height": "80",
      "id": "mycanvas"
    }
  }), _vm._v(" "), (_vm.showUp) ? _c('input', {
    staticClass: "button pointer",
    attrs: {
      "type": "button",
      "value": "上传"
    },
    on: {
      "click": _vm.uploadImg
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showUp) ? _c('input', {
    staticClass: "button pointer",
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": function($event) {
        _vm.setImagePreview(0)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74ca53f7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/uploadImg.vue
// module id = 1007
// module chunks = 2